import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from '../shared-modules/services/shared.service';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private _authService: AuthService, private _router: Router, private sharedService: AppService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // Uncomment once token is obtained in _authService
    /* if (this._authService.isAuthenticated()) {
      return true;
    } */

    if (this._authService.isAuthenticated()) {
      return true;  // Allow access to the route
    } else {
      this._router.navigate(['/login']);  // Redirect to login page if not authenticated
      return false;
    }
  }
}